// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__emvT6","titulo":"Faq_titulo__TbpCH","paragrafo":"Faq_paragrafo__yZHY+","listQuestions":"Faq_listQuestions__YkrSZ","btn":"Faq_btn__JW1kt"};